<script lang="ts">
  const gruppen = [
    {
      titel: 'PLZ-Bereich 880xx — Bodensee & Umgebung',
      orte: [
        ['88045', 'Friedrichshafen'],
        ['88046', 'Friedrichshafen'],
        ['88048', 'Friedrichshafen'],
        ['88069', 'Tettnang'],
        ['88074', 'Meckenbeuren'],
        ['88079', 'Kressbronn am Bodensee'],
        ['88085', 'Langenargen'],
        ['88090', 'Immenstaad am Bodensee'],
        ['88094', 'Oberteuringen'],
        ['88097', 'Eriskirch'],
        ['88099', 'Neukirch'],
      ],
    },
    {
      titel: 'PLZ-Bereich 881xx — Allgäu & Bodensee',
      orte: [
        ['88107', 'Lindau am Bodensee'],
        ['88131', 'Lindau am Bodensee'],
        ['88136', 'Isny im Allgäu'],
        ['88138', 'Hergensweiler'],
        ['88142', 'Wasserburg (Bodensee)'],
        ['88149', 'Nonnenhorn'],
        ['88161', 'Lindenberg im Allgäu'],
        ['88167', 'Weiler im Allgäu / Scheidegg / Heimenkirch'],
      ],
    },
    {
      titel: 'PLZ-Bereich 882xx — Ravensburg & Umland',
      orte: [
        ['88212', 'Ravensburg'],
        ['88213', 'Ravensburg'],
        ['88214', 'Ravensburg'],
        ['88217', 'Grünkraut'],
        ['88236', 'Zogenweiler'],
        ['88239', 'Wangen im Allgäu'],
        ['88250', 'Weingarten'],
        ['88255', 'Baindt'],
        ['88260', 'Argenbühl'],
        ['88263', 'Horgenzell'],
        ['88267', 'Vogt'],
        ['88271', 'Wilhelmsdorf'],
        ['88273', 'Fronreute'],
        ['88276', 'Berg'],
        ['88279', 'Amtzell'],
        ['88281', 'Schlier'],
        ['88284', 'Wolpertswende'],
        ['88285', 'Bodnegg'],
        ['88287', 'Grünkraut'],
        ['88289', 'Waldburg'],
        ['88299', 'Leutkirch im Allgäu'],
      ],
    },
    {
      titel: 'PLZ-Bereich 883xx — Oberschwaben',
      orte: [
        ['88316', 'Isny im Allgäu'],
        ['88319', 'Aitrach'],
        ['88326', 'Aulendorf'],
        ['88339', 'Bad Waldsee'],
        ['88348', 'Bad Saulgau'],
        ['88350', 'Kißlegg'],
        ['88353', 'Kißlegg'],
        ['88356', 'Ostrach'],
        ['88361', 'Altshausen'],
        ['88364', 'Wolfegg'],
        ['88367', 'Hohentengen'],
        ['88368', 'Bergatreute'],
        ['88370', 'Ebenweiler'],
        ['88371', 'Ebersbach-Musbach'],
        ['88373', 'Fleischwangen'],
        ['88374', 'Hoßkirch'],
        ['88377', 'Riedhausen'],
        ['88379', 'Guggenhausen'],
      ],
    },
    {
      titel: 'PLZ-Bereich 884xx — Biberach & Umgebung',
      orte: [
        ['88400', 'Biberach an der Riß'],
        ['88410', 'Bad Wurzach'],
        ['88416', 'Ochsenhausen'],
        ['88422', 'Bad Buchau'],
        ['88427', 'Bad Schussenried'],
        ['88430', 'Rot an der Rot'],
        ['88433', 'Schemmerhofen'],
        ['88436', 'Eberhardzell'],
        ['88437', 'Maselheim'],
        ['88441', 'Mittelbiberach'],
        ['88444', 'Ummendorf'],
        ['88447', 'Warthausen'],
        ['88448', 'Attenweiler'],
        ['88450', 'Berkheim'],
      ],
    },
  ];
</script>

<section id="servicegebiet" class="abschnitt">
  <div class="breite">
    <div class="mitte">
      <h2>Unser Vor-Ort-Servicegebiet</h2>
      <p class="vorspann">
        Vor-Ort-Termine bieten wir rund um den Bodensee, im Allgäu und in Oberschwaben an — Postleitzahlen
        88xxx. Telefon- und Fernwartungs-Support erreichst du unabhängig davon von überall.
      </p>
    </div>

    <div class="plz-gruppen">
      {#each gruppen as gruppe}
        <details class="plz-gruppe">
          <summary>{gruppe.titel}</summary>
          <ul class="plz-liste">
            {#each gruppe.orte as [plz, ort]}
              <li><span class="plz">{plz}</span> {ort}</li>
            {/each}
          </ul>
        </details>
      {/each}
    </div>

    <p class="mitte leise servicegebiet-hinweis">
      Deine Postleitzahl ist nicht dabei? Ruf uns trotzdem an — wir sagen dir ehrlich, ob ein Vor-Ort-Termin
      möglich ist.
    </p>
  </div>
</section>

<style>
  .plz-gruppen {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .plz-gruppe {
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: var(--tb-radius);
    padding: 0.25rem 1.75rem;
  }

  .plz-gruppe summary {
    cursor: pointer;
    padding: 1.15rem 0;
    font-weight: 700;
    color: var(--tb-navy-700);
    list-style: none;
  }

  .plz-gruppe summary::-webkit-details-marker {
    display: none;
  }

  .plz-gruppe summary::after {
    content: '+';
    float: right;
    font-weight: 900;
    color: var(--tb-text-600);
  }

  .plz-gruppe[open] summary::after {
    content: '−';
  }

  .plz-liste {
    list-style: none;
    padding: 0;
    margin: 0 0 1.5rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    gap: 0.3rem 1.5rem;
  }

  .plz-liste li {
    display: flex;
    gap: 0.6rem;
    padding: 0.3rem 0;
    border-top: 1px solid #eef2f6;
  }

  .plz-liste .plz {
    font-weight: 700;
    color: var(--tb-navy-900);
    flex: none;
  }

  .servicegebiet-hinweis {
    margin-top: 2.5rem;
  }
</style>
